import React, { ReactElement } from 'react'
import { Divider } from '@mui/material'

export const VerticalDivider = (): ReactElement => {
  return <Divider orientation="vertical" flexItem />
}
